<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="5%")
          span #
        th(width="35%" @click="sortOrder('operator_id')")
          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
        th.text-right(width="20%" @click="sortOrder('winlose')")
          span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
        th.text-right(width="20%" @click="sortOrder('actual_amount')")
          span(:title="$t('ui.actual_amount')") {{ $t('ui.actual_amount') }}
        th.text-right(width="20%" @click="sortOrder('rounded_amount')")
          span(:title="$t('ui.rounded_amount')") {{ $t('ui.rounded_amount') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(:colspan="5").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="item.operator_id") {{ item.operator_id }}
        td.text-right
          span.font-weight-bold(:title="$n(item.winlose, 'currency')" :class="$helpers.fontClassName(item.winlose)") {{ $n(item.winlose, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.actual_amount, 'currency')" :class="$helpers.fontClassName(item.actual_amount)") {{ $n(item.actual_amount, 'currency') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.rounded_amount, 'currency')" :class="$helpers.fontClassName(item.rounded_amount)") {{ $n(item.rounded_amount, 'currency') }}
      tr.footer
        td.text-right(colspan="2")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinlose)" :title="$n(subTotalWinlose, 'currency')") {{ $n(subTotalWinlose, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalActualAmount)" :title="$n(subTotalActualAmount, 'currency')") {{ $n(subTotalActualAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalRoundedAmount)" :title="$n(subTotalRoundedAmount, 'currency')") {{ $n(subTotalRoundedAmount, 'currency') }}
      tr.footer
        td.text-right(colspan="2")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinlose)" :title="$n(grandTotalWinlose, 'currency')") {{ $n(grandTotalWinlose, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalActualAmount)" :title="$n(grandTotalActualAmount, 'currency')") {{ $n(grandTotalActualAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRoundedAmount)" :title="$n(grandTotalRoundedAmount, 'currency')") {{ $n(grandTotalRoundedAmount, 'currency') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalWinlose: 0,
    grandTotalWinlose: 0,
    subTotalActualAmount: 0,
    grandTotalActualAmount: 0,
    subTotalRoundedAmount: 0,
    grandTotalRoundedAmount: 0,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalWinlose = 0
      this.grandTotalWinlose = 0
      this.subTotalActualAmount = 0
      this.grandTotalActualAmount = 0
      this.subTotalRoundedAmount = 0
      this.grandTotalRoundedAmount = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalWinlose = parseFloat(this.subTotalWinlose) + parseFloat(value["winlose"]);
          this.subTotalActualAmount = parseFloat(this.subTotalActualAmount) + parseFloat(value["actual_amount"]);
          this.subTotalRoundedAmount = parseFloat(this.subTotalRoundedAmount) + parseFloat(value["rounded_amount"]);
        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalWinlose = totalTbl[0]["winlose"];
          this.grandTotalActualAmount = totalTbl[0]["actual_amount"];
          this.grandTotalRoundedAmount = totalTbl[0]["rounded_amount"];
        }
      }
    }
  }
};
</script>
